import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Department } from '../models/department';
import { ParentDepartment } from '../models/parentdepartment';

@Injectable({
  providedIn: 'root'
})
export class ParentDepartmentService {
  apiEndpoint: string="";
  baseApiUrl: any;
  apiUniqueId: string = 'ParentDepartment/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E';

  constructor(private httpService: HttpWrapperService, 
    private http: HttpClient,
    private configService: ConfigService) { 
      this.apiEndpoint = this.configService.getConfigValue("apiEndpoint");
      this.apiEndpoint += this.apiUniqueId;
    }
    getAllParentDepartment(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<any>>{ 
      return this.httpService.get(this.apiEndpoint + '/getAllParentParentDepartments?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                   
        if (result.Success && result.Success ) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }

    viewParentDepartment(ParentDepartmentID?: string): Observable<Array<ParentDepartment>> {
      return this.httpService.get(this.apiEndpoint + '/viewParentDepartment/' + (ParentDepartmentID ? ParentDepartmentID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
    saveParentDepartment(Parentdepartments: ParentDepartment): Observable<any> { 
      return this.httpService.post(this.apiEndpoint + '/saveParentDepartment/', Parentdepartments).pipe(map((result: any) => {
        if (result.Success) { 
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    deleteParentDepartment(ParentDepartmentID?: string): Observable<any> {
      return this.httpService.post(this.apiEndpoint + '/deleteParentDepartment/' + (ParentDepartmentID ? ParentDepartmentID : '00000000-0000-0000-0000-000000000000'), ParentDepartmentID).pipe(map((result: any) => {
        if (result.Success) {
          return result.Data;
        } else {
          return [];
        }
      }));
    }
  
    checkDuplication(ParentDepartmentID?: string,ParentDepartmentCode?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkDuplication?&ParentDepartmentID=' + (ParentDepartmentID ? ParentDepartmentID : '00000000-0000-0000-0000-000000000000')+'&Code=' + (ParentDepartmentCode ? ParentDepartmentCode : '')).pipe(map((result: any) => {
          return result; 
      }));
    }

    checkEmail(Emailid?: string,ParentDepartmentID?: string): Observable<any> {
      return this.httpService.get(this.apiEndpoint + '/checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&ParentDepartmentID=' + (ParentDepartmentID ? ParentDepartmentID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
          return result; 
      }));
    }

  
  }

